module.exports = __webpack_public_path__ + "7672e69c8eb43c65b23a4a4953562375.svg";